module.exports = __webpack_public_path__ + "static/media/4 realistic feather wings eagle hawk 1.1280x1707.5ce381b4.webp";